import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import EndSidebar from "../EndSidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchBalance, fetchSipUserData, incrementLiveCalls, decrementLiveCalls } from "../../slices/WalletSlice";
import HandleCallCenter from "./HandleCallCenter";
import { BASE_DOMAIN } from "../phone/constant";
import { SIPProvider } from "react-sipjs";
import { io } from "socket.io-client";
import Footer from "../Footer";
import SSEListener from "../../components/SSEListener"
import { DecryptToken } from "../../helper/Constants";

const Layout = (props) => {
  const dispatch = useDispatch();
  const [openNav, setOpenNav] = useState(false);
  const [totalLiveCalls, setTotalLiveCalls] = useState(0);  
  const sip = useSelector((state) => state.wallet.extension_number);
  const userId = useSelector((state) => state.wallet.userId);
  const userToken = localStorage.getItem("psx_token");
  const decodedToken = DecryptToken(userToken);

  const OpenNavHandler = () => {
    setOpenNav(!openNav);
  };

  useEffect(() => {
    const body = document.querySelector("body");
    if (openNav) {
      body.classList.add("toggle-sidebar");
    } else {
      body.classList.remove("toggle-sidebar");
    }
  }, [openNav]);

  useEffect(() => {
    dispatch(fetchBalance());
    dispatch(fetchSipUserData());
  }, [dispatch]);

  return (
    <>
      <SIPProvider options={{ domain: BASE_DOMAIN, webSocketServer: window.VOIP_WS_URL }}>
        <SSEListener />
        {decodedToken?.user_id && (
          <Header openNav={openNav} navHandler={OpenNavHandler} user_id={decodedToken?.user_id} />
        )}
        <Sidebar openNav={openNav} navHandler={OpenNavHandler} />
        <EndSidebar openNav={openNav} navHandler={OpenNavHandler} />
        <HandleCallCenter />

        <div className="mt-[4rem]" />
        {/* Main content area with proper padding for sidebar */}
        <div className="transition-all duration-300 lg:ml-64">
          {props.children}
        </div>
        
        <Footer />
      </SIPProvider>
    </>
  );
};

export default Layout;